// --- Block early programmatic closes of the Quick View drawer & log caller ---
// --- Guard Quick View against early programmatic closes ---
// --- Quick View outside-close guard ---
(function () {
  let lastOpenAt = 0;
  const INSIDE_QV = 'quick-view-drawer, .quick-view, .quick-view__content';

  function guard(e) {
    const html = document.documentElement;
    const isOpen = html.classList.contains('quick-view--open') || html.classList.contains('quick-view--opening');
    if (!isOpen) return;

    // Always allow events inside the quick view
    if (e.target && e.target.closest && e.target.closest(INSIDE_QV)) {
      e.stopPropagation();
      return;
    }

    // Swallow outside interactions briefly after open
    if (Date.now() - lastOpenAt < 700) {
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();
    }
  }

  // Capture phase
  ['pointerdown','mousedown','touchstart','click','focusin','keydown'].forEach(t => {
    document.addEventListener(t, (e) => {
      if (e.type === 'keydown' && e.key !== 'Escape') return;
      guard(e);
    }, true);
  });

  // Let button mark open time
  window.__qv_mark_open = () => { lastOpenAt = Date.now(); };
})();

// --- Observe the <details> and the drawer for early hides ---
(function () {
  function getDetails() {
    const qv = document.querySelector('quick-view-drawer');
    return qv ? qv.closest('details') : null;
  }
  const html = document.documentElement;

  // A) body class removal
  new MutationObserver(() => {
    const hasClass = html.classList.contains('quick-view--open') || html.classList.contains('quick-view--opening');
    if (!hasClass) {
      const d = getDetails();
      const ms = Date.now() - (+d?.dataset?.qvOpenedAt || 0);
      if (d && ms < 800) {
        console.warn('Re-adding quick-view--open (removed early,', ms,'ms)');
        html.classList.add('quick-view--open');
      }
    }
  }).observe(html, { attributes: true, attributeFilter: ['class'] });

  // B) details.open flipping
  const moDetails = new MutationObserver((recs) => {
    for (const r of recs) {
      const d = r.target;
      if (!(d instanceof HTMLDetailsElement)) continue;
      if (!d.querySelector('.quick-view')) continue;
      const ms = Date.now() - (+d.dataset.qvOpenedAt || 0);
      if (!d.open && ms < 800) {
        console.warn('Blocked early removal of details.open at', ms,'ms');
        d.open = true; // put it back
      }
    }
  });
  // Start once the drawer exists
  const moStart = new MutationObserver(() => {
    const d = getDetails();
    if (d) {
      moDetails.observe(d, { attributes: true, attributeFilter: ['open'] });
      moStart.disconnect();
    }
  });
  moStart.observe(document.documentElement, { childList: true, subtree: true });
})();

// --- Guard Quick View against early programmatic closes ---
(function () {
  if (!window.MenuDrawer || !MenuDrawer.prototype) return;
  const originalClose = MenuDrawer.prototype.close;

  MenuDrawer.prototype.close = function (...args) {
    const isQuickView = this.matches && this.matches('quick-view-drawer');
    if (!isQuickView) return originalClose.apply(this, args);

    const openedAt = +this.dataset.qvOpenedAt || 0;
    const msSinceOpen = Date.now() - openedAt;

    if (msSinceOpen >= 0 && msSinceOpen < 800) {
      console.warn('❌ Blocked early Quick View close. msSinceOpen =', msSinceOpen);
      console.trace();
      return;
    }
    return originalClose.apply(this, args);
  };
})();


(function () {
  if (!window.MenuDrawer || !MenuDrawer.prototype) return;

  const originalClose = MenuDrawer.prototype.close;

  MenuDrawer.prototype.close = function (...args) {
    const isQuickView = this.matches && this.matches('quick-view-drawer');
    if (!isQuickView) {
      return originalClose.apply(this, args);
    }

    const openedAt = +this.dataset.qvOpenedAt || 0;
    const msSinceOpen = Date.now() - openedAt;

    if (msSinceOpen >= 0 && msSinceOpen < 800) {
      console.warn('❌ Blocked early Quick View close. msSinceOpen =', msSinceOpen);
      console.trace();
      return; // swallow close
    }

    return originalClose.apply(this, args);
  };
})();


(function () {
  if (!window.MenuDrawer || !MenuDrawer.prototype) return;

  const originalClose = MenuDrawer.prototype.close;

  MenuDrawer.prototype.close = function (...args) {
    // Only guard Quick View
    const isQuickView = this.matches && this.matches('quick-view-drawer');
    if (!isQuickView) return originalClose.apply(this, args);

    const openedAt = +this.dataset.qvOpenedAt || 0;
    const msSinceOpen = Date.now() - openedAt;

    // If something tries to close within 800ms of opening, block and log it
    if (msSinceOpen >= 0 && msSinceOpen < 800) {
      console.warn('Blocked early Quick View close. msSinceOpen =', msSinceOpen);
      console.trace();
      return; // swallow
    }

    return originalClose.apply(this, args);
  };
})();

// Log when quick-view--open is removed, and re-add it within 800ms of open
(function () {
  const html = document.documentElement;
  const mo = new MutationObserver(() => {
    const has = html.classList.contains('quick-view--open') || html.classList.contains('quick-view--opening');
    if (!has) {
      const drawer = document.querySelector('quick-view-drawer');
      const openedAt = +drawer?.dataset?.qvOpenedAt || 0;
      const ms = Date.now() - openedAt;
      console.warn('quick-view--open removed. msSinceOpen =', ms);
      if (openedAt && ms < 800) {
        console.warn('Re-adding quick-view--open (early removal)');
        html.classList.add('quick-view--open');
      }
    }
  });
  mo.observe(html, { attributes: true, attributeFilter: ['class'] });
})();


// ---- Strong outside-click guard for Quick View ----
(function () {
  let lastOpenAt = 0;
  let qvRootSelector = 'quick-view-drawer, .quick-view, .quick-view__content';

  // Common handler used by multiple event types, in CAPTURE phase
  function guard(e) {
    const html = document.documentElement;
    const isOpen = html.classList.contains('quick-view--open') || html.classList.contains('quick-view--opening');
    if (!isOpen) return;

    // Always allow interactions inside the quick view
    if (e.target.closest(qvRootSelector)) {
      e.stopPropagation();
      return;
    }

    // Swallow outside interactions for a short grace period after open
    if (Date.now() - lastOpenAt < 500) {
      e.stopPropagation();
      e.preventDefault();
      // Be extra strict for early-phase handlers
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }

  // Capture phase listeners (many outside-closers use pointerdown/mousedown)
  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(type => {
    document.addEventListener(type, guard, true);
  });

  // Let the button tell us when we just opened
  window.__qv_mark_open = () => { lastOpenAt = Date.now(); };
})();


// ---- Quick View anti-flash-close guard + debugger ----
(function () {
  let lastOpenAt = 0;
  let qvDetails = null;

  // Mark when QV is opened (from your button code or MenuDrawer)
  document.addEventListener('quickview:open', () => {
    lastOpenAt = Date.now();
    // find the details that contains the quick view
    qvDetails = document.querySelector('quick-view-drawer')?.closest('details');
  });

  // 1) Stop outside-click closers for the first 500ms
  document.addEventListener('click', (e) => {
    const html = document.documentElement;
    const isOpen = html.classList.contains('quick-view--open') || html.classList.contains('quick-view--opening');
    if (!isOpen) return;

    // clicks inside quick view are fine
    if (e.target.closest('quick-view-drawer, .quick-view, .quick-view__content')) {
      e.stopPropagation();
      return;
    }

    // swallow outside clicks for a short grace period
    if (Date.now() - lastOpenAt < 500) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true); // capture

  // 2) If something still closes the <details>, immediately reopen and log it
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement)) return;
    if (!d.querySelector('.quick-view')) return;

    const justOpened = Date.now() - lastOpenAt < 500;

    // Debug log of every toggle
    console.log('QuickView <details> toggled. open =', d.open, 'ms since open =', Date.now() - lastOpenAt);
    console.trace();

    // If it closed right after opening, force it back open
    if (!d.open && justOpened) {
      d.open = true;
      e.stopImmediatePropagation();
    }
  }, true);
})();



class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      // Re-enable summary clicks after close
      const summary = this.querySelector('summary');
      if (summary) summary.style.pointerEvents = '';

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}

customElements.define('quick-view-drawer', QuickViewDrawer);
(function () {
  const qvDetails = () => document.querySelector('quick-view-drawer')?.closest('details');

  // Wrap the `open` property on <details> to block closing the Quick View
  const detailsProto = HTMLDetailsElement.prototype;
  const desc = Object.getOwnPropertyDescriptor(detailsProto, 'open');

  if (desc && desc.set) {
    Object.defineProperty(detailsProto, 'open', {
      ...desc,
      set: function (val) {
        const isQuickView = this.contains(document.querySelector('quick-view-drawer'));
        const justOpened = document.documentElement.classList.contains('quick-view--open') ||
                           document.documentElement.classList.contains('quick-view--opening');

        // Block setting open=false if it's the Quick View and it just opened
        if (isQuickView && justOpened && val === false) {
          console.warn('Blocked close attempt on Quick View <details> from', new Error().stack);
          return;
        }

        return desc.set.call(this, val);
      }
    });
  }
})();

// 2) Button: always swallow the trigger click; then open safely
class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = this.closest('.card-wrapper');
      const drawer  = wrapper && wrapper.querySelector('quick-view-drawer');

      if (!drawer) {
        if (this.dataset.productUrl) window.location.href = this.dataset.productUrl;
        return;
      }

      const summary = drawer.querySelector('summary');
      const details = summary && summary.closest('details');
      const insideSummary = !!this.closest('summary');

      // >>> PLACE THE SNIPPET HERE (this whole setTimeout block) <<<
      setTimeout(() => {
        if (insideSummary) {
          if (details && !details.open) {
            details.open = true;
            if (drawer) drawer.dataset.qvOpenedAt = String(Date.now());
            details.classList.add('menu-opening');
            requestAnimationFrame(() => details.classList.remove('menu-opening'));
          }
        } else {
          summary && summary.click(); // let MenuDrawer run its open flow

        }

        // Mark open time for the MenuDrawer.close guard
        if (drawer) drawer.dataset.qvOpenedAt = String(Date.now());

        // (Optional) ensure the page has the open class
        document.documentElement.classList.add('quick-view--open');

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: { productUrl: this.dataset.productUrl }
        }));
      }, 0);
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);



// customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
